// Scope the virtual-list workaround to narrow touch screens only.
const activity = new WeakMap();
const mobile = () => window.matchMedia('(max-width: 750px) and (pointer: coarse)').matches;
function track(element) {
  if (!element || !mobile()) return () => {};
  const state = { touching: false, last: -Infinity, position: element.scrollTop };
  activity.set(element, state);
  const start = () => { state.touching = true; };
  const end = () => { state.touching = false; state.last = Date.now(); };
  const scroll = () => { state.last = Date.now(); };
  const events = [['touchstart', start], ['touchend', end], ['touchcancel', end], ['scroll', scroll]];
  events.forEach(([name, fn]) => element.addEventListener(name, fn, { passive: true }));
  return () => {
    events.forEach(([name, fn]) => element.removeEventListener(name, fn));
    activity.delete(element);
  };
}
function canReset(element) {
  if (!mobile()) return true;
  const state = activity.get(element);
  // Check compositor movement too, even when scroll events are delayed.
  if (state && state.position !== element.scrollTop) {
    state.position = element.scrollTop;
    state.last = Date.now();
  }
  return !!state && !state.touching && Date.now() - state.last > 800;
}
module.exports = { track, canReset };
